export const CODE_COOLDOWN_MS = 30_000;

export const shouldSendCode = (sentAt: number | null, now: number): boolean =>
  sentAt === null || now - sentAt >= CODE_COOLDOWN_MS;

export const remainingSeconds = (sentAt: number, now: number): number =>
  Math.max(0, Math.ceil((CODE_COOLDOWN_MS - (now - sentAt)) / 1000));

export const formatCooldown = (seconds: number): string => {
  const minutes = Math.floor(seconds / 60);
  const rest = seconds % 60;
  return `${minutes}:${rest.toString().padStart(2, "0")}`;
};
